/**
 * @module modules/query-count-sk
 * @description <h2><code>query-count-sk</code></h2>
 *
 * Reports the number of matches for a given query.
 *
 * @attr {string} current_query - The current query to count against.
 *
 * @attr {string} url - The URL to POST the query to.
 *
 * @evt paramset-changed - An event with the updated paramset in e.detail
 *   from the fetch response.
 *
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "QueryCountSk", {
    enumerable: true,
    get: function() {
        return QueryCountSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _task = require("@lit/task");
const _jsonOrThrow = require("../../../infra-sk/modules/jsonOrThrow");
const _errorMessage = require("../errorMessage");
require("../../../elements-sk/modules/spinner-sk");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let QueryCountSk = class QueryCountSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        // Reset count to 0 while loading to match legacy behavior.
        const isLoading = this._fetchTask.status === _task.TaskStatus.PENDING || this._fetchTask.status === _task.TaskStatus.INITIAL;
        var _this__fetchTask_value;
        const count = isLoading ? 0 : (_this__fetchTask_value = this._fetchTask.value) !== null && _this__fetchTask_value !== void 0 ? _this__fetchTask_value : 0;
        return (0, _lit.html)`
      <div>
        <span>${count}</span>
        <spinner-sk ?active=${isLoading}></spinner-sk>
      </div>
    `;
    }
    constructor(...args){
        super(...args);
        this.url = '';
        this.current_query = '';
        this._fetchTask = new _task.Task(this, {
            task: async ([url, current_query], { signal })=>{
                if (!url || !current_query) {
                    return 0;
                }
                const now = Math.floor(Date.now() / 1000);
                const body = {
                    q: current_query,
                    end: now,
                    begin: now - 24 * 60 * 60
                };
                try {
                    const response = await fetch(url, {
                        method: 'POST',
                        signal,
                        body: JSON.stringify(body),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                    const json = await (0, _jsonOrThrow.jsonOrThrow)(response);
                    this.dispatchEvent(new CustomEvent('paramset-changed', {
                        detail: json.paramset,
                        bubbles: true,
                        composed: true
                    }));
                    return json.count;
                } catch (msg) {
                    if (msg.name === 'AbortError') {
                        throw msg;
                    }
                    (0, _errorMessage.errorMessage)(msg);
                    throw msg;
                }
            },
            args: ()=>[
                    this.url,
                    this.current_query
                ]
        });
    }
};
_ts_decorate([
    (0, _decorators.property)({
        type: String
    }),
    _ts_metadata("design:type", String)
], QueryCountSk.prototype, "url", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: String,
        attribute: 'current_query'
    }),
    _ts_metadata("design:type", String)
], QueryCountSk.prototype, "current_query", void 0);
QueryCountSk = _ts_decorate([
    (0, _decorators.customElement)('query-count-sk')
], QueryCountSk);
